import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function TrialBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user || user.role !== 'owner') return null;
  if (user.subscription_status === 'active') return null;

  // If trial_ends_at is set use it; otherwise derive from created_at + 30 days
  const trialEnd = user.trial_ends_at
    ? new Date(user.trial_ends_at)
    : new Date(new Date(user.created_at).getTime() + 30 * 24 * 60 * 60 * 1000);

  const now      = new Date();
  const daysLeft = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));

  // Only show within the last 7 days of an active (not yet expired) trial
  if (daysLeft > 7 || daysLeft <= 0) return null;

  const isUrgent = daysLeft <= 3;

  return (
    <div
      className={`border-b px-4 py-2.5 text-sm flex items-center justify-center gap-3 flex-wrap ${
        isUrgent
          ? 'bg-red-50 text-red-700 border-red-200'
          : 'bg-orange-50 text-orange-700 border-orange-200'
      }`}
      data-testid="trial-banner"
      role="alert"
    >
      <span>
        Your trial ends in{' '}
        <strong>{daysLeft} day{daysLeft !== 1 ? 's' : ''}</strong>.
        {isUrgent ? ' Upgrade now to avoid losing access.' : ' Upgrade to keep your access.'}
      </span>
      <button
        onClick={() => navigate('/billing')}
        className={`shrink-0 font-semibold text-xs px-3 py-1.5 rounded-full transition-colors ${
          isUrgent
            ? 'bg-red-600 hover:bg-red-700 text-white'
            : 'bg-orange-500 hover:bg-orange-600 text-white'
        }`}
        data-testid="trial-banner-upgrade-btn"
      >
        Upgrade Now
      </button>
    </div>
  );
}
